import React from "react";
import STRaiseRequestFormShow from "../PureComponents/STRaiseRequestFormShow";

const RenderSTRaiseRequestFormShow = () => {
  return <STRaiseRequestFormShow />;
};

export default RenderSTRaiseRequestFormShow;
